import React from 'react';
import { Link } from 'react-router-dom';
import { neighborhoods } from '../data/neighborhoods';
import { Trash2Icon, HammerIcon, HardHatIcon, WarehouseIcon, SprayCanIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const icons = [Trash2Icon, HammerIcon, HardHatIcon, WarehouseIcon, SprayCanIcon];
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="w-full bg-white py-20 lg:py-28" data-id="element-194" data-mp="13x61w0v8odya">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-195" data-mp="z43ekah220qj">
        <div className="max-w-2xl" data-id="element-196" data-mp="u61nb29h6v3z">
          <h2 className="font-display text-3xl font-black tracking-tight text-forest sm:text-4xl lg:text-5xl" data-id="element-197" data-mp="u73au67oha2l">
            {t.services.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-neutral-600" data-id="element-198" data-mp="l5djf0dsqb4t">
            {t.services.intro}
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-neutral-600" data-id="element-199" data-mp="g6k18unkdvyb">
            {t.areas.availabilityPrefix}{' '}
            {neighborhoods.map((neighborhood, index) => <React.Fragment key={neighborhood.slug} data-id="element-200" data-mp="3b369dh8ly4vn" data-mpi={index}>
                <Link to={`/${neighborhood.slug}`} className="font-semibold text-rust underline decoration-rust/30 underline-offset-2 transition-colors duration-150 ease-out hover:text-rust-dark" data-id="element-201" data-mp="3b3zi2nr4n4gf">
                  {neighborhood.name}
                </Link>
                {index < neighborhoods.length - 2 ? ', ' : index === neighborhoods.length - 2 ? ' & ' : '.'}
              </React.Fragment>)}
          </p>
        </div>

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-202" data-mp="3l0uff3bnyyt4">
          {t.services.items.map((service, index) => {
          const Icon = icons[index];
          return <li key={service.title} className="h-full" data-id="element-203" data-mp="29mgy6hbf1hm2" data-mpi={index}>
                <a href="#contact" className="group flex h-full flex-col rounded-lg border border-neutral-200 bg-sand p-7 transition-[border-color,background-color,transform] duration-200 ease-out hover:-translate-y-1 hover:border-rust hover:bg-white" data-id="element-204" data-mp="29juexkf5xdo0">
                  <span className="mb-6 flex h-12 w-12 items-center justify-center rounded-md bg-forest text-white transition-colors duration-200 ease-out group-hover:bg-rust" data-id="element-205" data-mp="1gpfwgqgnmvny">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-206" data-mp="16uwazcbdfa3b" />
                  </span>
                  <h3 className="font-display text-xl font-bold text-forest" data-id="element-207" data-mp="11syma2k7bn2z">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-neutral-600" data-id="element-208" data-mp="sttnqw8n3tqt">
                    {service.description}
                  </p>
                  <span className="mt-auto flex items-center gap-2 pt-6 text-sm font-bold text-rust" data-id="element-209" data-mp="2s5mo92umzh8a">
                    {t.services.cardCta}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-210" data-mp="2urdketi3eejj" />
                  </span>
                </a>
              </li>;
        })}

          <li className="h-full" data-id="element-211" data-mp="34jjdk6k2z20b">
            <div className="flex h-full flex-col justify-between rounded-lg bg-forest p-7" data-id="element-212" data-mp="39gjige571ypu">
              <div data-id="element-213" data-mp="2bt1ctc6txcq2">
                <h3 className="font-display text-xl font-bold text-white" data-id="element-214" data-mp="2btt6ghgv90dp">
                  {t.services.promptTitle}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-white/75" data-id="element-215" data-mp="2gtfjoqwp2gmi">
                  {t.services.promptBody}
                </p>
              </div>
              <a href="#contact" className="mt-6 inline-flex w-full items-center justify-center rounded-md bg-rust px-5 py-3 text-center text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-rust-dark" data-id="element-216" data-mp="2pt2akirss41b">
                {t.services.promptCta}
              </a>
            </div>
          </li>
        </ul>
      </div>
    </section>;
}